import { Button, FormGroup, Input } from "reactstrap";
import Card from "@components/ui-components/card";
import Flex from "@components/ui-components/flex";
import ImageWrapper from "@components/ui-components/image-wrapper";
import themeConfig from "@src/configs/theme-config";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const SurveyPreview = ({ activeId }) => {
    const { t } = useTranslation();
    const { watch } = useFormContext();
    const renderRatingScale = () => {
        if (watch("survey_type") === "csat") {
            return (
                <div className="mb-4">
                    <Flex
                        justify="center"
                        align="center"
                        wrap
                        className="mb-1 font-medium-2">
                        {Object.values(watch("response_values") || {}).map(
                            (label, index) => (
                                <Button
                                    key={index}
                                    color="primary"
                                    outline
                                    className="mb-25">
                                    {label || `Rating ${index + 1}`}
                                </Button>
                            )
                        )}
                    </Flex>
                    <Flex justify="between" className="text-muted small">
                        <span>{watch("bad_rating_text") || "Bad"}</span>
                        <span>{watch("good_rating_text") || "Good"}</span>
                    </Flex>
                </div>
            );
        } else {
            // NPS
            return (
                <div className="mb-4">
                    <Flex
                        justify="center"
                        align="center"
                        wrap
                        className="mb-1font-medium-2">
                        {Array.from({ length: 11 }, (_, i) => (
                            <Button
                                key={i}
                                color="primary"
                                size="sm"
                                outline
                                className="p-2 mb-25">
                                {i}
                            </Button>
                        ))}
                    </Flex>
                    <Flex
                        justify="between"
                        align="center"
                        className="mb-3 text-muted small">
                        <span>
                            0 -{" "}
                            {watch("bad_rating_text") || "Not likely at all"}
                        </span>
                        <span>
                            10 -{" "}
                            {watch("good_rating_text") || "Extremely likely"}
                        </span>
                    </Flex>
                </div>
            );
        }
    };

    return (
        <Card header={<h3 className="text-center mt-2">{t("Survey Preview")}</h3>}>
            <>
                <div className="border rounded p-4 mb-3">
                    <Flex justify="center" align="center" className="mb-2">
                        <ImageWrapper width={200} src={themeConfig.app.logo} />
                    </Flex>
                    {!activeId.thankYouMessage ? (
                        <>
                            {watch("additional_message") && (
                                <h3 className="mb-4 text-center">
                                    {watch("additional_message")}
                                </h3>
                            )}
                            <h4 className="my-3 text-center">
                                {watch("question_message") ||
                                    "How likely are you to recommend our service to others?"}
                            </h4>

                            {renderRatingScale()}

                            {watch(activeId.additionalComment) ? (
                                <div className="mb-4">
                                    <FormGroup>
                                        <Input
                                            type="textarea"
                                            value={watch(
                                                activeId.additionalComment
                                            )}
                                            placeholder="Additional Comment"
                                            rows={3}
                                            readOnly
                                            className="survey-preview-textarea" />
                                    </FormGroup>
                                </div>
                            ) : null}
                            <Flex justify="end">
                                <Button color="primary">{t("Submit Feedback")}</Button>
                            </Flex>
                        </>
                    ) : (
                        <>
                            <div className="text-center py-3">
                                <h1>{t("Thank You!")}</h1>
                                <ImageWrapper
                                    width={100}
                                    src="common/success.svg" />
                            </div>
                            <div className="border-top pt-3 font-medium-5 text-center">
                                {t(watch(activeId.thankYouMessage))}
                            </div>
                        </>
                    )}
                </div>
            </>
        </Card>
    );
};

export default SurveyPreview;
